import { registerContainerUIElement, registerUIElement } from '@/elements/elementStorage';
import { ContainerState } from '@/elements/base/ContainerState';
import { ComponentElementState } from '@/elements/ComponentElement/ComponentElementState';
import { RalAttributeState } from '@/elements/attributes/RalAttribute/RalAttributeState';
import { CompositeProductInfoState } from '@/elements/CompositeProductInfo/CompositeProductInfoState';
import { TextAttributeState } from '@/elements/attributes/TextAttribute/TextAttributeState';
import { HtmlBlockState } from '@/elements/HtmlBlock/HtmlBlockState';

import { ContainerCfgUIElement } from '@/elements/containers/FallbackContainer/FallbackContainer';
import { RootContainerCfgUIElement } from '@/elements/containers/RootContainer/RootContainer';
import { MixedContainerCfgUIElement } from '@/elements/containers/MixedContainer/MixedContainer';
import { ComponentItemsContainerCfgUIElement } from '@/elements/containers/ComponentItemsContainer/ComponentItemsContainer';
import { ProductsContainerCfgUIElement } from '@/elements/containers/ProductsContainer/ProductsContainer';

import { TextAttributeCfgUIElement } from '@/elements/attributes/TextAttribute/TextAttribute';
import { BooleanAttributeCfgUIElement } from '@/elements/attributes/BooleanAttribute/BooleanAttribute';
import { IntegerAttributeCfgUIElement } from '@/elements/attributes/IntegerAttribute/IntegerAttribute';
import { DecimalAttributeCfgUIElement } from '@/elements/attributes/DecimalAttribute/DecimalAttribute';
import { RalAttributeCfgUIElement } from '@/elements/attributes/RalAttribute/RalAttribute';
import { ComponentCfgUIElement } from '@/elements/ComponentElement/ComponentElement';
import { CompositeProductInfoUIElement } from '@/elements/CompositeProductInfo/CompositeProductInfo';
import { HtmlBlockUIElement } from '@/elements/HtmlBlock/HtmlBlock';

import {
  IUICfgAttributeBoolean,
  IUICfgAttributeDecimal,
  IUICfgAttributeInteger,
  IUICfgAttributeRal,
  IUICfgAttributeText,
  IUICfgComponent,
  IUICfgComponentItemsContainer,
  IUICfgMixedContainer,
  IUICfgProductsMergeContainer,
  IUICfgRootContainer,
  IUICfgUICompositeProductInfoElementUI,
  IUICfgUIHtmlBlockUIElement,
} from '@canvas-logic/clp-api-types';
import { DecimalAttributeState } from '@/elements/attributes/DecimalAttribute/DecimalAttributeState';
import { BooleanAttributeState } from '@/elements/attributes/BooleanAttribute/BooleanAttributeState';
import { IntegerAttributeState } from '@/elements/attributes/IntegerAttribute/IntegerAttributeState';

registerUIElement<IUICfgAttributeRal>('attribute', 'RAL', {
  init: ({ api, viewElement }) => {
    return new RalAttributeState(api, viewElement);
  },
  Component: RalAttributeCfgUIElement,
});
registerUIElement<IUICfgAttributeText>('attribute', 'text', {
  init: ({ api, viewElement }) => {
    return new TextAttributeState(api, viewElement);
  },
  Component: TextAttributeCfgUIElement,
});

registerUIElement<IUICfgAttributeBoolean>('attribute', 'boolean', {
  init: ({ api, viewElement }) => {
    return new BooleanAttributeState(api, viewElement);
  },
  Component: BooleanAttributeCfgUIElement,
});
registerUIElement<IUICfgAttributeInteger>('attribute', 'integer', {
  init: ({ api, viewElement }) => {
    return new IntegerAttributeState(api, viewElement);
  },
  Component: IntegerAttributeCfgUIElement,
});
registerUIElement<IUICfgAttributeDecimal>('attribute', 'decimal', {
  init: ({ api, viewElement }) => {
    return new DecimalAttributeState(api, viewElement);
  },
  Component: DecimalAttributeCfgUIElement,
});
registerUIElement<IUICfgComponent>('component', 'default', {
  init: ({ api, viewElement }) => {
    return new ComponentElementState(api, viewElement);
  },
  Component: ComponentCfgUIElement,
});

registerUIElement<IUICfgUIHtmlBlockUIElement>('ui-element', 'HTMLBlock', {
  init: ({ viewElement }) => {
    return new HtmlBlockState(viewElement);
  },
  Component: HtmlBlockUIElement,
});

registerContainerUIElement('container', 'mixed-container', {
  init: ({ viewElement, children }) => {
    return new ContainerState(children, viewElement as IUICfgMixedContainer);
  },
  Component: MixedContainerCfgUIElement,
});

registerContainerUIElement('container', 'root-container', {
  init: ({ viewElement, children }) => {
    return new ContainerState(children, viewElement as IUICfgRootContainer);
  },
  Component: RootContainerCfgUIElement,
});

registerContainerUIElement('container', 'component-items-container', {
  init: ({ viewElement, children }) => {
    return new ContainerState(children, viewElement as IUICfgComponentItemsContainer);
  },
  Component: ComponentItemsContainerCfgUIElement,
});

registerContainerUIElement('container', 'element-container', {
  init: ({ viewElement, children }) => {
    return new ContainerState(children, viewElement);
  },
  Component: ContainerCfgUIElement,
});

registerContainerUIElement('container', 'product-merge-container', {
  init: ({ viewElement, children }) => {
    return new ContainerState(children, viewElement as IUICfgProductsMergeContainer);
  },
  Component: ProductsContainerCfgUIElement,
});

registerUIElement<IUICfgUICompositeProductInfoElementUI>('ui-element', 'composite-product-info', {
  init: ({ api, viewElement }) => {
    return new CompositeProductInfoState(api, viewElement);
  },
  Component: CompositeProductInfoUIElement,
});
